import { Injectable } from '@angular/core';
import _ from 'lodash';

abstract class DistanceConverter {
  public abstract toMiles(value: number): number;
  public abstract toKilometers(value: number): number;
  public abstract getUnit(): string;

  public convert(value: number, unit: string): number {
    switch (unit) {
      default:
      case DistanceConverterService.DISTANCES.MILES:
        return this.toMiles(value);

      case DistanceConverterService.DISTANCES.KILOMETERS:
        return this.toKilometers(value);
    }
  }
}

class MilesConverter extends DistanceConverter {
  public toMiles(miles: number): number {
    return miles;
  }

  public toKilometers(miles: number): number {
    return miles * 1.609344;
  }

  public getUnit(): string {
    return 'mi';
  }
}

class KilometersConverter extends DistanceConverter {
  public toMiles(kilometers: number): number {
    return kilometers * 0.621371;
  }

  public toKilometers(kilometers: number): number {
    return kilometers;
  }

  public getUnit(): string {
    return 'km';
  }
}

class DistanceConverterFactory {
  public static getConverterFactory(type: string): DistanceConverter {
    switch (type) {
      default:
      case DistanceConverterService.DISTANCES.MILES:
        return new MilesConverter();

      case DistanceConverterService.DISTANCES.KILOMETERS:
        return new KilometersConverter();
    }
  }
}

@Injectable()
export class DistanceConverterService {
  public static readonly DISTANCES = {
    KILOMETERS: 'KM',
    MILES: 'MI'
  };
  public static readonly DEFAULT_DISTANCE = DistanceConverterService.DISTANCES
    .MILES;

  private distance: string = DistanceConverterService.DEFAULT_DISTANCE;

  /**
   * Set the distance for conversions
   * @param value New distance
   */
  public setDistance(value: string) {
    this.distance =
      value && _.values(DistanceConverterService.DISTANCES).indexOf(value) > -1
        ? value
        : DistanceConverterService.DEFAULT_DISTANCE;
  }

  /**
   * Convert from one distance unit to another
   * @param value Distance value to convert
   * @param unit Distance unit of the value
   * @param inverse Indicates the direction of the conversion
   */
  public convert(
    value: number,
    unit: string = DistanceConverterService.DEFAULT_DISTANCE,
    inverse: boolean = false
  ) {
    if (value == null) {
      return 0;
    }

    unit =
      unit && _.values(DistanceConverterService.DISTANCES).indexOf(unit) > -1
        ? unit
        : DistanceConverterService.DEFAULT_DISTANCE;

    return DistanceConverterFactory.getConverterFactory(
      !inverse ? unit : this.distance
    ).convert(value, !inverse ? this.distance : unit);
  }

  /**
   * Get unit symbol of the current distance unit
   */
  public getUnit() {
    return DistanceConverterFactory.getConverterFactory(
      this.distance
    ).getUnit();
  }
}
